
/* eslint-disable @typescript-eslint/no-var-requires */
const { Engine } = require('@babylonjs/core/Engines/engine')
const { Scene } = require('@babylonjs/core/scene')
const { Color3 } = require('@babylonjs/core/Maths/math.color')
const { SceneLoader } = require('@babylonjs/core/Loading/sceneLoader')
const { HDRCubeTexture } = require('@babylonjs/core/Materials/Textures/hdrCubeTexture')
const { PBRMaterial } = require('@babylonjs/core/Materials/PBR/pbrMaterial')
const { DefaultRenderingPipeline } = require('@babylonjs/core/PostProcesses/RenderPipeline/Pipelines/defaultRenderingPipeline')

require('@babylonjs/core/Helpers/sceneHelpers')
require('@babylonjs/core/Loading/loadingScreen')
require('@babylonjs/loaders/glTF')

let engine: any, scene: any

const initScene = async(canvas: HTMLCanvasElement, loader: HTMLElement,
  modelUrl: string, modelFormat: string, modelTexture: string) => {

  const showSceneLoader = () => {
    loader.style.display = 'block'
  }
  const hideSceneLoader = () => {
    loader.style.display = 'none'
  }
  showSceneLoader()

  engine = new Engine(canvas)

  scene = new Scene(engine)
  await SceneLoader.ImportMeshAsync('', modelUrl, modelFormat, scene)

  scene.executeWhenReady(() => {
    hideSceneLoader()
  })

  scene.skipFrustumClipping = true
  scene.createDefaultCamera(true)

  const camera = scene.activeCamera
  camera.alpha += Math.PI
  camera.useFramingBehavior = true
  camera.useAutoRotationBehavior = true

  const framingBehavior = camera.getBehaviorByName('Framing')
  framingBehavior.framingTime = 0
  framingBehavior.elevationReturnTime = -1

  if (scene.meshes.length) {
    camera.lowerRadiusLimit = null
    const worldExtends = scene.getWorldExtends(
      (mesh:any) => mesh.isVisible && mesh.isEnabled()
    )
    framingBehavior.zoomOnBoundingInfo(
      worldExtends.min,
      worldExtends.max
    )
  }

  camera.pinchPrecision = 200 / camera.radius
  camera.lowerRadiusLimit *= 2
  camera.upperRadiusLimit = 5 * camera.radius
  camera.wheelDeltaPercentage = 0.01
  camera.pinchDeltaPercentage = 0.01
  camera.attachControl()

  scene.meshes.forEach((mesh:any) => {
    if (mesh.material instanceof PBRMaterial) {
      mesh.material.subSurface.indexOfRefraction = 1.5
      mesh.material.subSurface.volumeIndexOfRefraction = 1.5
      mesh.material.subSurface.refractionTexture = null
    }
  })

  scene.clearColor = new Color3(0.4, 0.4, 0.4).toLinearSpace()

  scene.environmentTexture = new HDRCubeTexture(
    // Copy from https://polyhaven.com/a/christmas_photo_studio_05
    // (CC0 License HDR)
    modelTexture,
    scene,
    128,
    false,
    true,
    false,
    true
  )

  scene.createDefaultEnvironment({
    createGround: true,
    groundSize: 1,
    groundColor: new Color3(0.6, 0.6, 0.6).toLinearSpace(),
    groundOpacity: 0.5,
    enableGroundShadow: false,
    enableGroundMirror: true,
    groundMirrorBlurKernel: 32,
    groundMirrorAmount: 2,
    createSkybox: false
  })

  scene.createDefaultSkybox(
    scene.environmentTexture.clone(),
    true,
    10000,
    0.15 // .1 is totally blurry. .01 is not blurry at all
  )

  const pipeline = new DefaultRenderingPipeline(
    'default',
    true,
    scene,
    scene.cameras
  )

  pipeline.imageProcessing.exposure = 1.5
  pipeline.samples = 1
  pipeline.fxaaEnabled = true
  pipeline.sharpenEnabled = true
  pipeline.sharpen.edgeAmount = 0.2

  resizeEngine()

  return scene
}
const destroyScene = () => {
  engine.stopRenderLoop()
  scene.dispose()
  engine.dispose()
  scene = undefined
  engine = undefined
}

const resizeEngine = () => {
  window.addEventListener('resize', function() {
    if (engine)
      engine.resize()
  })
}
const createScene = (canvas: HTMLCanvasElement, loader: HTMLElement, modelUrl: string, modelFormat: string, modelTexture:string) => {
  initScene(canvas, loader,  modelUrl, modelFormat, modelTexture).then((scene:any) => {
    scene.whenReadyAsync().then(() => {
      engine.runRenderLoop(() => {
        scene.render()
      })
    })
  })
}

export { createScene, destroyScene }
